// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.faux-label[data-v-2d03a811]\n{\n  background: rgba(0,0,0,.12); \n  width: 6em; \n  height: 1em;\n  margin-bottom: 0.5em;\n}\n.faux-input[data-v-2d03a811]\n{\n  background: rgba(0,0,0,.12); \n  width: 95%; \n  height: 2.1em;\n  margin-bottom: 1em;\n}\n", ""]);
// Exports
module.exports = exports;
